import { Injectable } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { Observable, of, Subject, Subscription, throwError, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  url: string;
  private subject = new Subject<any>();
  public seletedScreenName: BehaviorSubject<string> =  new BehaviorSubject<string>(undefined);

  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private cookieService: CookieService,
    @Inject( DOCUMENT ) private document: Document

  )
   {
    this.url=environment.baseUrl;
   }

   sendProjectData(projectData){
    this.subject.next({ projectData });
  }
  
   getProjectData(): Observable<any> {
    return this.subject.asObservable();
  }
   nonemptyfields(){
     //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/project/nonemptyfields
     return this.http.get(this.url+ '/HuLoopRest/huloop/project/nonemptyfields')
   }

   nondeletesettings(){
    return this.http.get(this.url+ '/HuLoopRest/huloop/project/nondeletesettings')
   }
   getunmaskable(){
    return this.http.get(this.url+ '/HuLoopRest/huloop/project/getunmaskable')
   }

   //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/project/getAllProjectSettings/61276c94a1f486a24017af5e
   getAllProjectSetting(projectId){
    return this.http.get(this.url+ '/HuLoopRest/huloop/project/getAllProjectSettings/' + projectId)
   }
   getAwsSetting(projectId){
    return this.http.get(this.url+ '/HuLoopRest/huloop/project/getAwsSetting/' + projectId)
   }
//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/locator/locatorSuite/61276c94a1f486a24017af5e/6136ed08f6361d48c296a647
   getLocatorValue(projectId, locatorId){
     return this.http.get(this.url + '/HuLoopRest/huloop/locator/locatorSuite/' + projectId + '/' + locatorId)
   }

   //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/locator/editLocatorSuiteTitle

   editLocatorSuitTitle(title){
     return this.http.post(this.url + '/HuLoopRest/huloop/locator/editLocatorSuiteTitle', title)
   }
   editLocatorSuite(projectId,locatorSuite){
    return this.http.post(this.url + '/HuLoopRest/huloop/locator/editLocatorSuite/'+ projectId, locatorSuite, {responseType: 'text'}
    )
   }
   editMultiLocatoSuite(projectId, locatorSuite){
    return this.http.post(this.url + '/HuLoopRest/huloop/locator/editMultiLocators/' + projectId , locatorSuite,  {responseType: 'text'});
   }
  updateAwsSetting(projectId,key,value, objectForUpdate){
    return this.http.put(this.url+ '/HuLoopRest/huloop/project/updateAwsSetting/'+ projectId ,objectForUpdate)
  }
  deleteLocator(projectId,screenId){
   return this.http.delete(this.url+'/HuLoopRest/huloop/locator/deleteLocator/' + projectId +'/' + screenId)
  }
  //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/project/nonemptyfields
 nonEmptyFeilds(){
   return this.http.get(this.url + '/HuLoopRest/huloop/project/nonemptyfields');
 }
 //
 getUnMaskedValue(){
   //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/project/getunmaskable
   return this.http.get(this.url+"/HuLoopRest/huloop/project/getunmaskable");
 }

 getNonDeleteSetting()
 {
  return this.http.get(this.url+"/HuLoopRest/huloop/project/nondeletesettings");
 }

 addSetting(projectId, body)
 {
    return this.http.post(this.url+"/HuLoopRest/huloop/project/addProjectSetting/" + projectId , body);
 }

 deleteSetting(projectId , body)
 {
  return this.http.post( this.url+"/HuLoopRest/huloop/project/delProjectSetting/" + projectId, body);
 }

 testConnection(projectId, dbName)
 {
    return this.http.get(this.url + "/HuLoopRest/huloop/project/testDBConnection/" + projectId + "/" + dbName);
 }
 encryptSetting(projectId, payLoad){
  return this.http.put(this.url+ "/HuLoopRest/huloop/project/encryptSetting/" +projectId,payLoad)
 }

 //https://beatblipdemo.agreeya.net:6283/HuLoopRest/huloop/project/decryptSetting/63510f01e4b072fce05a08aa

 decryptSetting(projectId,payLoad){
  return this.http.put(this.url+ "/HuLoopRest/huloop/project/decryptSetting/" +projectId,payLoad)
 }
}
